import { USER_RIGHTS_CONSTANTS } from './constants'
import * as rest from '../../services'
export const getRights = (user) => {
  return (dispatch) => {
    dispatch({ type: USER_RIGHTS_CONSTANTS.GET_USER_RIGHTS_REQUEST })
    return new rest.UserService(user.url)
      .getUserRights()
      .then((response) => {
        dispatch({
          type: USER_RIGHTS_CONSTANTS.GET_USER_RIGHTS_SUCCESS,
          response,
        })
      })
      .catch((errors) => {
        dispatch({
          type: USER_RIGHTS_CONSTANTS.GET_USER_RIGHTS_FAILURE,
          errors,
        })
      })
  }
}
